// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/harness.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { Channel, ChannelAccount, ChannelAccountBindingMode, ChannelSession, ChannelUserBinding, ChatPolicy } from "../v1/channel_pb.js";
import { file_agentplatform_v1_channel } from "../v1/channel_pb.js";
import type { BackgroundTask } from "../v1/harness_pb.js";
import { file_agentplatform_v1_harness } from "../v1/harness_pb.js";
import type { Job, JobRun } from "../v1/job_pb.js";
import { file_agentplatform_v1_job } from "../v1/job_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/harness.proto.
 */
export const file_agentplatform_httpv2_harness: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_channel, file_agentplatform_v1_harness, file_agentplatform_v1_job, file_buf_validate_validate, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListJobsResponse
 */
export type ListJobsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListJobsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListJobsData data = 4;
   */
  data?: ListJobsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListJobsResponse.
 * Use `create(ListJobsResponseSchema)` to create a new message.
 */
export const ListJobsResponseSchema: GenMessage<ListJobsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListJobsData
 */
export type ListJobsData = Message<"infinigence.infini.agentplatform.httpv2.ListJobsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Job items = 1;
   */
  items: Job[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListJobsData.
 * Use `create(ListJobsDataSchema)` to create a new message.
 */
export const ListJobsDataSchema: GenMessage<ListJobsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetJobRequest
 */
export type GetJobRequest = Message<"infinigence.infini.agentplatform.httpv2.GetJobRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetJobRequest.
 * Use `create(GetJobRequestSchema)` to create a new message.
 */
export const GetJobRequestSchema: GenMessage<GetJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetJobResponse
 */
export type GetJobResponse = Message<"infinigence.infini.agentplatform.httpv2.GetJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Job data = 4;
   */
  data?: Job | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetJobResponse.
 * Use `create(GetJobResponseSchema)` to create a new message.
 */
export const GetJobResponseSchema: GenMessage<GetJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateJobRequest
 */
export type UpdateJobRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateJobRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 任务体 / Job body
   * @gotags: json:"job"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Job job = 2;
   */
  job?: Job | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateJobRequest.
 * Use `create(UpdateJobRequestSchema)` to create a new message.
 */
export const UpdateJobRequestSchema: GenMessage<UpdateJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateJobResponse
 */
export type UpdateJobResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Job data = 4;
   */
  data?: Job | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateJobResponse.
 * Use `create(UpdateJobResponseSchema)` to create a new message.
 */
export const UpdateJobResponseSchema: GenMessage<UpdateJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteJobRequest
 */
export type DeleteJobRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteJobRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteJobRequest.
 * Use `create(DeleteJobRequestSchema)` to create a new message.
 */
export const DeleteJobRequestSchema: GenMessage<DeleteJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 6);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteJobResponse
 */
export type DeleteJobResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteJobResponse.
 * Use `create(DeleteJobResponseSchema)` to create a new message.
 */
export const DeleteJobResponseSchema: GenMessage<DeleteJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PauseJobRequest
 */
export type PauseJobRequest = Message<"infinigence.infini.agentplatform.httpv2.PauseJobRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PauseJobRequest.
 * Use `create(PauseJobRequestSchema)` to create a new message.
 */
export const PauseJobRequestSchema: GenMessage<PauseJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 8);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PauseJobResponse
 */
export type PauseJobResponse = Message<"infinigence.infini.agentplatform.httpv2.PauseJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Job data = 4;
   */
  data?: Job | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PauseJobResponse.
 * Use `create(PauseJobResponseSchema)` to create a new message.
 */
export const PauseJobResponseSchema: GenMessage<PauseJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ResumeJobRequest
 */
export type ResumeJobRequest = Message<"infinigence.infini.agentplatform.httpv2.ResumeJobRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ResumeJobRequest.
 * Use `create(ResumeJobRequestSchema)` to create a new message.
 */
export const ResumeJobRequestSchema: GenMessage<ResumeJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ResumeJobResponse
 */
export type ResumeJobResponse = Message<"infinigence.infini.agentplatform.httpv2.ResumeJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Job data = 4;
   */
  data?: Job | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ResumeJobResponse.
 * Use `create(ResumeJobResponseSchema)` to create a new message.
 */
export const ResumeJobResponseSchema: GenMessage<ResumeJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListJobRunsResponse
 */
export type ListJobRunsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListJobRunsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListJobRunsData data = 4;
   */
  data?: ListJobRunsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListJobRunsResponse.
 * Use `create(ListJobRunsResponseSchema)` to create a new message.
 */
export const ListJobRunsResponseSchema: GenMessage<ListJobRunsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListJobRunsData
 */
export type ListJobRunsData = Message<"infinigence.infini.agentplatform.httpv2.ListJobRunsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.JobRun items = 1;
   */
  items: JobRun[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListJobRunsData.
 * Use `create(ListJobRunsDataSchema)` to create a new message.
 */
export const ListJobRunsDataSchema: GenMessage<ListJobRunsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetJobRunRequest
 */
export type GetJobRunRequest = Message<"infinigence.infini.agentplatform.httpv2.GetJobRunRequest"> & {
  /**
   * 任务 ID / Job ID
   * @gotags: json:"job_id"
   *
   * @generated from field: string job_id = 1 [json_name = "job_id"];
   */
  jobId: string;

  /**
   * 运行记录 ID / Run ID
   * @gotags: json:"run_id"
   *
   * @generated from field: string run_id = 2 [json_name = "run_id"];
   */
  runId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetJobRunRequest.
 * Use `create(GetJobRunRequestSchema)` to create a new message.
 */
export const GetJobRunRequestSchema: GenMessage<GetJobRunRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetJobRunResponse
 */
export type GetJobRunResponse = Message<"infinigence.infini.agentplatform.httpv2.GetJobRunResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.JobRun data = 4;
   */
  data?: JobRun | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetJobRunResponse.
 * Use `create(GetJobRunResponseSchema)` to create a new message.
 */
export const GetJobRunResponseSchema: GenMessage<GetJobRunResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListBackgroundTasksResponse
 */
export type ListBackgroundTasksResponse = Message<"infinigence.infini.agentplatform.httpv2.ListBackgroundTasksResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListBackgroundTasksData data = 4;
   */
  data?: ListBackgroundTasksData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListBackgroundTasksResponse.
 * Use `create(ListBackgroundTasksResponseSchema)` to create a new message.
 */
export const ListBackgroundTasksResponseSchema: GenMessage<ListBackgroundTasksResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListBackgroundTasksData
 */
export type ListBackgroundTasksData = Message<"infinigence.infini.agentplatform.httpv2.ListBackgroundTasksData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.BackgroundTask items = 1;
   */
  items: BackgroundTask[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListBackgroundTasksData.
 * Use `create(ListBackgroundTasksDataSchema)` to create a new message.
 */
export const ListBackgroundTasksDataSchema: GenMessage<ListBackgroundTasksData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetBackgroundTaskRequest
 */
export type GetBackgroundTaskRequest = Message<"infinigence.infini.agentplatform.httpv2.GetBackgroundTaskRequest"> & {
  /**
   * 后台任务 ID / Background task ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetBackgroundTaskRequest.
 * Use `create(GetBackgroundTaskRequestSchema)` to create a new message.
 */
export const GetBackgroundTaskRequestSchema: GenMessage<GetBackgroundTaskRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetBackgroundTaskResponse
 */
export type GetBackgroundTaskResponse = Message<"infinigence.infini.agentplatform.httpv2.GetBackgroundTaskResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.BackgroundTask data = 4;
   */
  data?: BackgroundTask | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetBackgroundTaskResponse.
 * Use `create(GetBackgroundTaskResponseSchema)` to create a new message.
 */
export const GetBackgroundTaskResponseSchema: GenMessage<GetBackgroundTaskResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelsResponse
 */
export type ListChannelsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListChannelsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListChannelsData data = 4;
   */
  data?: ListChannelsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelsResponse.
 * Use `create(ListChannelsResponseSchema)` to create a new message.
 */
export const ListChannelsResponseSchema: GenMessage<ListChannelsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 20);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelsData
 */
export type ListChannelsData = Message<"infinigence.infini.agentplatform.httpv2.ListChannelsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Channel items = 1;
   */
  items: Channel[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelsData.
 * Use `create(ListChannelsDataSchema)` to create a new message.
 */
export const ListChannelsDataSchema: GenMessage<ListChannelsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelSessionsResponse
 */
export type ListChannelSessionsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListChannelSessionsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListChannelSessionsData data = 4;
   */
  data?: ListChannelSessionsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelSessionsResponse.
 * Use `create(ListChannelSessionsResponseSchema)` to create a new message.
 */
export const ListChannelSessionsResponseSchema: GenMessage<ListChannelSessionsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelSessionsData
 */
export type ListChannelSessionsData = Message<"infinigence.infini.agentplatform.httpv2.ListChannelSessionsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChannelSession items = 1;
   */
  items: ChannelSession[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelSessionsData.
 * Use `create(ListChannelSessionsDataSchema)` to create a new message.
 */
export const ListChannelSessionsDataSchema: GenMessage<ListChannelSessionsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelSessionRequest
 */
export type GetChannelSessionRequest = Message<"infinigence.infini.agentplatform.httpv2.GetChannelSessionRequest"> & {
  /**
   * 渠道会话 ID / Channel session ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelSessionRequest.
 * Use `create(GetChannelSessionRequestSchema)` to create a new message.
 */
export const GetChannelSessionRequestSchema: GenMessage<GetChannelSessionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelSessionResponse
 */
export type GetChannelSessionResponse = Message<"infinigence.infini.agentplatform.httpv2.GetChannelSessionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelSession data = 4;
   */
  data?: ChannelSession | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelSessionResponse.
 * Use `create(GetChannelSessionResponseSchema)` to create a new message.
 */
export const GetChannelSessionResponseSchema: GenMessage<GetChannelSessionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelSessionRequest
 */
export type UpdateChannelSessionRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelSessionRequest"> & {
  /**
   * 渠道会话 ID / Channel session ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 渠道会话体（仅 state 可更新；account_id / channel_user_id 不可变）
   * Channel session body (only state is mutable; account_id / channel_user_id are immutable)
   * @gotags: json:"session"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelSession session = 2;
   */
  session?: ChannelSession | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelSessionRequest.
 * Use `create(UpdateChannelSessionRequestSchema)` to create a new message.
 */
export const UpdateChannelSessionRequestSchema: GenMessage<UpdateChannelSessionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelSessionResponse
 */
export type UpdateChannelSessionResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelSessionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelSession data = 4;
   */
  data?: ChannelSession | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelSessionResponse.
 * Use `create(UpdateChannelSessionResponseSchema)` to create a new message.
 */
export const UpdateChannelSessionResponseSchema: GenMessage<UpdateChannelSessionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelSessionRequest
 */
export type DeleteChannelSessionRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelSessionRequest"> & {
  /**
   * 渠道会话 ID / Channel session ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelSessionRequest.
 * Use `create(DeleteChannelSessionRequestSchema)` to create a new message.
 */
export const DeleteChannelSessionRequestSchema: GenMessage<DeleteChannelSessionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 28);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelSessionResponse
 */
export type DeleteChannelSessionResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelSessionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelSessionResponse.
 * Use `create(DeleteChannelSessionResponseSchema)` to create a new message.
 */
export const DeleteChannelSessionResponseSchema: GenMessage<DeleteChannelSessionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 29);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsResponse
 */
export type ListChannelUserBindingsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsData data = 4;
   */
  data?: ListChannelUserBindingsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsResponse.
 * Use `create(ListChannelUserBindingsResponseSchema)` to create a new message.
 */
export const ListChannelUserBindingsResponseSchema: GenMessage<ListChannelUserBindingsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 30);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsData
 */
export type ListChannelUserBindingsData = Message<"infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChannelUserBinding items = 1;
   */
  items: ChannelUserBinding[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelUserBindingsData.
 * Use `create(ListChannelUserBindingsDataSchema)` to create a new message.
 */
export const ListChannelUserBindingsDataSchema: GenMessage<ListChannelUserBindingsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 31);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelUserBindingRequest
 */
export type GetChannelUserBindingRequest = Message<"infinigence.infini.agentplatform.httpv2.GetChannelUserBindingRequest"> & {
  /**
   * 渠道用户绑定 ID / Channel user binding ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelUserBindingRequest.
 * Use `create(GetChannelUserBindingRequestSchema)` to create a new message.
 */
export const GetChannelUserBindingRequestSchema: GenMessage<GetChannelUserBindingRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 32);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelUserBindingResponse
 */
export type GetChannelUserBindingResponse = Message<"infinigence.infini.agentplatform.httpv2.GetChannelUserBindingResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUserBinding data = 4;
   */
  data?: ChannelUserBinding | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelUserBindingResponse.
 * Use `create(GetChannelUserBindingResponseSchema)` to create a new message.
 */
export const GetChannelUserBindingResponseSchema: GenMessage<GetChannelUserBindingResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 33);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingRequest
 */
export type UpdateChannelUserBindingRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingRequest"> & {
  /**
   * 渠道用户绑定 ID / Channel user binding ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 绑定体（仅 tool_permissions 会被采纳）/ Binding body (only tool_permissions is applied)
   * @gotags: json:"channel_user_binding"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUserBinding channel_user_binding = 2 [json_name = "channel_user_binding"];
   */
  channelUserBinding?: ChannelUserBinding | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingRequest.
 * Use `create(UpdateChannelUserBindingRequestSchema)` to create a new message.
 */
export const UpdateChannelUserBindingRequestSchema: GenMessage<UpdateChannelUserBindingRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 34);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingResponse
 */
export type UpdateChannelUserBindingResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUserBinding data = 4;
   */
  data?: ChannelUserBinding | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelUserBindingResponse.
 * Use `create(UpdateChannelUserBindingResponseSchema)` to create a new message.
 */
export const UpdateChannelUserBindingResponseSchema: GenMessage<UpdateChannelUserBindingResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 35);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingRequest
 */
export type DeleteChannelUserBindingRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingRequest"> & {
  /**
   * 渠道用户绑定 ID / Channel user binding ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingRequest.
 * Use `create(DeleteChannelUserBindingRequestSchema)` to create a new message.
 */
export const DeleteChannelUserBindingRequestSchema: GenMessage<DeleteChannelUserBindingRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 36);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingResponse
 */
export type DeleteChannelUserBindingResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelUserBindingResponse.
 * Use `create(DeleteChannelUserBindingResponseSchema)` to create a new message.
 */
export const DeleteChannelUserBindingResponseSchema: GenMessage<DeleteChannelUserBindingResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 37);

/**
 * 飞书一键注册状态返回体 / Feishu one-click register status payload
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.FeishuRegisterStatus
 */
export type FeishuRegisterStatus = Message<"infinigence.infini.agentplatform.httpv2.FeishuRegisterStatus"> & {
  /**
   * @gotags: json:"registration_id"
   *
   * @generated from field: string registration_id = 1 [json_name = "registration_id"];
   */
  registrationId: string;

  /**
   * 注册流程状态 / State of the registration process
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.FeishuRegisterState status = 2;
   */
  status: FeishuRegisterState;

  /**
   * @gotags: json:"qr_code_url,omitempty"
   *
   * @generated from field: string qr_code_url = 3 [json_name = "qr_code_url"];
   */
  qrCodeUrl: string;

  /**
   * 仅当 status = COMPLETED 时填充 / Only populated when status = COMPLETED
   * @gotags: json:"channel_account,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount channel_account = 4 [json_name = "channel_account"];
   */
  channelAccount?: ChannelAccount | undefined;

  /**
   * 仅当 status = FAILED 时填充 / Only populated when status = FAILED
   * @gotags: json:"error,omitempty"
   *
   * @generated from field: string error = 5;
   */
  error: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.FeishuRegisterStatus.
 * Use `create(FeishuRegisterStatusSchema)` to create a new message.
 */
export const FeishuRegisterStatusSchema: GenMessage<FeishuRegisterStatus> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 38);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.StartFeishuRegisterRequest
 */
export type StartFeishuRegisterRequest = Message<"infinigence.infini.agentplatform.httpv2.StartFeishuRegisterRequest"> & {
  /**
   * 新建渠道账号名称（创建模式）/ New channel account name (create mode)
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 智能体 ID（INSTANCE 模式为 Application ID，TEMPLATE 模式为 Agent 模版 ID）
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 2 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 绑定模式 / Binding mode
   * @gotags: json:"binding_mode,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountBindingMode binding_mode = 3 [json_name = "binding_mode"];
   */
  bindingMode: ChannelAccountBindingMode;

  /**
   * 聊天策略 / Chat policy
   * @gotags: json:"chat_policy,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChatPolicy chat_policy = 4 [json_name = "chat_policy"];
   */
  chatPolicy?: ChatPolicy | undefined;

  /**
   * 传入已有 App ID 进入更新模式；为空则创建新应用 / Existing App ID for update mode
   * @gotags: json:"existing_app_id,omitempty"
   *
   * @generated from field: string existing_app_id = 5 [json_name = "existing_app_id"];
   */
  existingAppId: string;

  /**
   * 更新模式下关联的渠道账号 ID / Channel account ID bound in update mode
   * @gotags: json:"existing_account_id,omitempty"
   *
   * @generated from field: string existing_account_id = 6 [json_name = "existing_account_id"];
   */
  existingAccountId: string;

  /**
   * 增量权限（在平台基础模板之上叠加）/ Extra scopes (added on top of the base template)
   * @gotags: json:"extra_scopes,omitempty"
   *
   * @generated from field: repeated string extra_scopes = 7 [json_name = "extra_scopes"];
   */
  extraScopes: string[];

  /**
   * @gotags: json:"extra_events,omitempty"
   *
   * @generated from field: repeated string extra_events = 8 [json_name = "extra_events"];
   */
  extraEvents: string[];

  /**
   * @gotags: json:"extra_callbacks,omitempty"
   *
   * @generated from field: repeated string extra_callbacks = 9 [json_name = "extra_callbacks"];
   */
  extraCallbacks: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.StartFeishuRegisterRequest.
 * Use `create(StartFeishuRegisterRequestSchema)` to create a new message.
 */
export const StartFeishuRegisterRequestSchema: GenMessage<StartFeishuRegisterRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 39);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.StartFeishuRegisterResponse
 */
export type StartFeishuRegisterResponse = Message<"infinigence.infini.agentplatform.httpv2.StartFeishuRegisterResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.FeishuRegisterStatus data = 4;
   */
  data?: FeishuRegisterStatus | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.StartFeishuRegisterResponse.
 * Use `create(StartFeishuRegisterResponseSchema)` to create a new message.
 */
export const StartFeishuRegisterResponseSchema: GenMessage<StartFeishuRegisterResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 40);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusRequest
 */
export type GetFeishuRegisterStatusRequest = Message<"infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusRequest"> & {
  /**
   * 注册流水 ID / Registration ID
   * @gotags: json:"registration_id"
   *
   * @generated from field: string registration_id = 1 [json_name = "registration_id"];
   */
  registrationId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusRequest.
 * Use `create(GetFeishuRegisterStatusRequestSchema)` to create a new message.
 */
export const GetFeishuRegisterStatusRequestSchema: GenMessage<GetFeishuRegisterStatusRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 41);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusResponse
 */
export type GetFeishuRegisterStatusResponse = Message<"infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.FeishuRegisterStatus data = 4;
   */
  data?: FeishuRegisterStatus | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetFeishuRegisterStatusResponse.
 * Use `create(GetFeishuRegisterStatusResponseSchema)` to create a new message.
 */
export const GetFeishuRegisterStatusResponseSchema: GenMessage<GetFeishuRegisterStatusResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_harness, 42);

/**
 * 飞书一键注册状态 / Feishu one-click register state
 *
 * @generated from enum infinigence.infini.agentplatform.httpv2.FeishuRegisterState
 */
export enum FeishuRegisterState {
  /**
   * 未指定 / unspecified
   *
   * @generated from enum value: FEISHU_REGISTER_STATE_UNSPECIFIED = 0;
   */
  FEISHU_REGISTER_STATE_UNSPECIFIED = 0,

  /**
   * 已生成二维码，等待扫码 / QR code generated, waiting for user to scan
   *
   * @generated from enum value: SCANNING = 1;
   */
  SCANNING = 1,

  /**
   * 注册成功 / Registration completed successfully
   *
   * @generated from enum value: COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * 注册失败 / Registration failed
   *
   * @generated from enum value: FAILED = 3;
   */
  FAILED = 3,

  /**
   * 用户已授权，正在创建渠道账号 / User authorized, creating channel account
   *
   * @generated from enum value: CREATING = 4;
   */
  CREATING = 4,
}

/**
 * Describes the enum infinigence.infini.agentplatform.httpv2.FeishuRegisterState.
 */
export const FeishuRegisterStateSchema: GenEnum<FeishuRegisterState> = /*@__PURE__*/
  enumDesc(file_agentplatform_httpv2_harness, 0);

/**
 * HarnessHTTPV2Service Harness（定时任务 / 任务运行 / 后台任务 / 渠道会话 / 渠道用户绑定 / 飞书一键注册）HTTP V2 服务。
 * Harness HTTP V2 service: cron jobs, job runs, background tasks, channels, channel sessions,
 * channel user bindings and Feishu one-click registration.
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service
 */
export const HarnessHTTPV2Service: GenService<{
  /**
   * 列出定时任务 / List cron jobs
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListJobsResponseSchema;
  },
  /**
   * 获取定时任务 / Get cron job
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetJob
   */
  getJob: {
    methodKind: "unary";
    input: typeof GetJobRequestSchema;
    output: typeof GetJobResponseSchema;
  },
  /**
   * 更新定时任务 / Update cron job
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.UpdateJob
   */
  updateJob: {
    methodKind: "unary";
    input: typeof UpdateJobRequestSchema;
    output: typeof UpdateJobResponseSchema;
  },
  /**
   * 删除定时任务 / Delete cron job
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.DeleteJob
   */
  deleteJob: {
    methodKind: "unary";
    input: typeof DeleteJobRequestSchema;
    output: typeof DeleteJobResponseSchema;
  },
  /**
   * 暂停定时任务 / Pause cron job
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.PauseJob
   */
  pauseJob: {
    methodKind: "unary";
    input: typeof PauseJobRequestSchema;
    output: typeof PauseJobResponseSchema;
  },
  /**
   * 恢复定时任务 / Resume cron job
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ResumeJob
   */
  resumeJob: {
    methodKind: "unary";
    input: typeof ResumeJobRequestSchema;
    output: typeof ResumeJobResponseSchema;
  },
  /**
   * 列出任务运行记录 / List job runs
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListJobRuns
   */
  listJobRuns: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListJobRunsResponseSchema;
  },
  /**
   * 获取任务运行记录 / Get job run
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetJobRun
   */
  getJobRun: {
    methodKind: "unary";
    input: typeof GetJobRunRequestSchema;
    output: typeof GetJobRunResponseSchema;
  },
  /**
   * 列出后台任务 / List background tasks
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListBackgroundTasks
   */
  listBackgroundTasks: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListBackgroundTasksResponseSchema;
  },
  /**
   * 获取后台任务 / Get background task
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetBackgroundTask
   */
  getBackgroundTask: {
    methodKind: "unary";
    input: typeof GetBackgroundTaskRequestSchema;
    output: typeof GetBackgroundTaskResponseSchema;
  },
  /**
   * 列出渠道 / List channels
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListChannels
   */
  listChannels: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListChannelsResponseSchema;
  },
  /**
   * 列出渠道会话 / List channel sessions
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListChannelSessions
   */
  listChannelSessions: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListChannelSessionsResponseSchema;
  },
  /**
   * 获取渠道会话 / Get channel session
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetChannelSession
   */
  getChannelSession: {
    methodKind: "unary";
    input: typeof GetChannelSessionRequestSchema;
    output: typeof GetChannelSessionResponseSchema;
  },
  /**
   * 更新渠道会话 / Update channel session
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.UpdateChannelSession
   */
  updateChannelSession: {
    methodKind: "unary";
    input: typeof UpdateChannelSessionRequestSchema;
    output: typeof UpdateChannelSessionResponseSchema;
  },
  /**
   * 删除渠道会话 / Delete channel session
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.DeleteChannelSession
   */
  deleteChannelSession: {
    methodKind: "unary";
    input: typeof DeleteChannelSessionRequestSchema;
    output: typeof DeleteChannelSessionResponseSchema;
  },
  /**
   * 列出渠道用户绑定 / List channel user bindings
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.ListChannelUserBindings
   */
  listChannelUserBindings: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListChannelUserBindingsResponseSchema;
  },
  /**
   * 获取渠道用户绑定 / Get channel user binding
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetChannelUserBinding
   */
  getChannelUserBinding: {
    methodKind: "unary";
    input: typeof GetChannelUserBindingRequestSchema;
    output: typeof GetChannelUserBindingResponseSchema;
  },
  /**
   * 更新渠道用户绑定（仅 tool_permissions）/ Update channel user binding (tool_permissions only)
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.UpdateChannelUserBinding
   */
  updateChannelUserBinding: {
    methodKind: "unary";
    input: typeof UpdateChannelUserBindingRequestSchema;
    output: typeof UpdateChannelUserBindingResponseSchema;
  },
  /**
   * 删除渠道用户绑定 / Delete channel user binding
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.DeleteChannelUserBinding
   */
  deleteChannelUserBinding: {
    methodKind: "unary";
    input: typeof DeleteChannelUserBindingRequestSchema;
    output: typeof DeleteChannelUserBindingResponseSchema;
  },
  /**
   * 飞书一键注册：发起 / Feishu one-click register: start
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.StartFeishuRegister
   */
  startFeishuRegister: {
    methodKind: "unary";
    input: typeof StartFeishuRegisterRequestSchema;
    output: typeof StartFeishuRegisterResponseSchema;
  },
  /**
   * 飞书一键注册：查询状态 / Feishu one-click register: poll status
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.HarnessHTTPV2Service.GetFeishuRegisterStatus
   */
  getFeishuRegisterStatus: {
    methodKind: "unary";
    input: typeof GetFeishuRegisterStatusRequestSchema;
    output: typeof GetFeishuRegisterStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_harness, 0);

